const BASE = '/api/data';
const VIEW_UNAVAILABLE_MESSAGE = 'Unable to load this view right now.';

export async function fetchApi<T = unknown>(
  type: string,
  params?: Record<string, string>,
): Promise<T> {
  const search = new URLSearchParams({ type, ...params });
  let res: Response;
  try {
    res = await fetch(`${BASE}?${search}`, {
      signal: AbortSignal.timeout(30_000),
    });
  } catch {
    throw new Error(VIEW_UNAVAILABLE_MESSAGE);
  }
  const json = await res.json().catch(() => null);
  if (!res.ok) {
    const message = typeof json?.error === 'string'
      ? json.error
      : VIEW_UNAVAILABLE_MESSAGE;
    throw new Error(message);
  }
  return json.data as T;
}
